import { render, staticRenderFns } from "./BarApp.vue?vue&type=template&id=3cb78666"
import script from "./BarApp.vue?vue&type=script&lang=js"
export * from "./BarApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports